import React from 'react';

export default ({
  input,
  label,
  type,
  className,
  autoComplete,
  maxLength,
  placeholder,
  readOnly,
  style,
  onPaste,
  meta: { error, touched }
}) => (
  
  <React.Fragment>
    <input
      {...input}
      placeholder={placeholder}
      type={type}
      className={className}
      autoComplete={autoComplete}
      maxLength={maxLength}
      readOnly={readOnly}
      style={style}
    />
    {touched && (error && <span>{error}</span>)}
  </React.Fragment>
);
